import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTenantPublishStatus } from "../../redux/slices/common/tenantSlice";

const TenantPublishStatusModal = () => {
  const dispatch = useDispatch();
  const { publishBuildState } = useSelector((state) => state.tenant || {});

  const isPending = publishBuildState === "pending";

  useEffect(() => {
    if (!isPending) return undefined;

    dispatch(getTenantPublishStatus());
    const intervalId = window.setInterval(() => {
      dispatch(getTenantPublishStatus());
    }, 5000);

    return () => window.clearInterval(intervalId);
  }, [dispatch, isPending]);

  return null;
};

export default TenantPublishStatusModal;
